import React, { useEffect, useState, useCallback } from 'react';
// import useFavorites from '../hooks/useFavorites';
import axios from 'axios';
import {
  BookOpen,
  PrayersList,
  SearchBar,
  DayCard,
  LoadMoreButton,
  SeasonsDropdown,
  PrayerTypesDropdown
} from '../components';
import { Skeleton } from '../components/ui/skeleton';
import { toggleFavorite, fetchPrayerRitesListData } from '../utilities/api';
import useLiturgicalEvents from '../hooks/useLiturgicalEvents';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { mapPrayerRitesListData } from "../utilities";
const staticEvents = [
  { title: 'Day', date: '2024-12-25T10:30:00', classNames: ['bda-abstinence-event'] },
];
function PagePrayerAndRites() {
  // const { favoriteIds, loadFavorites, setFavoriteIds, loadingFavorites } = useFavorites(); // Use hook
  const [prayersData, setPrayersData] = useState({ items: [] });
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [searchItems, setSearchItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [apiEvents, setApiEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getFilter, setFilter } = useState({});
  const [debouncedSeason, setDebouncedSeason] = useState("all");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [debouncedCategory, setDebouncedCategory] = useState("all");
  const [selectedSeason, setSelectedSeason] = useState("all");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [offset, setOffset] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerBatch, setItemsPerBatch] = useState(9);
  const itemsPerPage = 10;
  const today = new Date();
  const { isDataLoading, eventData } = useLiturgicalEvents(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  // Ensure skeleton stays until API data is loaded
  useEffect(() => {
    if (!isDataLoading && eventData) {
      setIsLoading(false); // Hide skeleton only when API data is fully loaded
    }
  }, [isDataLoading, eventData]);
  // Extract relevant event details
  const firstEventKey = eventData ? Object.keys(eventData)[0] : null;
  const firstEvent = firstEventKey ? eventData[firstEventKey] : null;
  // Ensure no flickering or static data issues
  const dayData = isDataLoading
    ? {} //Show skeleton while loading (NO STATIC DATA)
    : {
      date: firstEvent?.date
        ? new Date(firstEvent.date * 1000).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
        : "",
      title: firstEvent?.name || "",
      tag: firstEvent?.liturgicalSeasonLcl || "",
      label: firstEvent ? "Today" : "",
      category: "Easter",
      description: firstEvent?.eventData?.description || '',
    };

  const filteredEvents = useCallback(() => {
    const allEvents = [...staticEvents, ...apiEvents];
    return allEvents;
  }, [apiEvents, staticEvents]);

  // Debounce the search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    const controller = new AbortController();
    let mounted = true;

    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);

        const responsetest = await fetchPrayerRitesListData(
          0,
          itemsPerPage,
          debouncedSearchQuery,
          debouncedCategory,
          debouncedSeason
        );

        const mappedData = mapPrayerRitesListData(
          responsetest?.data || [],
          responsetest?.included || []
        );

        const total = responsetest?.meta?.pagination?.total || 0;

        if (!Array.isArray(mappedData)) {
          console.error("Error, : MappedData is not an Array", mappedData);
          return;
        }

        if (mounted) {
          setPrayersData({
            items: mappedData.map(item => ({
              ...item,
              // favorite: favoriteIds.has(item.id),
            }))
          });
          setOffset(itemsPerPage);
          setHasMore(total > itemsPerPage);

          
          setTotalItems(total);
          setOffset(itemsPerPage);
          setHasMore(total > itemsPerPage);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error("Error loading data:", err);
          if (mounted) setError(err.message || "Failed to load data");
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadData();
    return () => {
      mounted = false;
      controller.abort(); // Only cancel request when unmounting
    };
  }, [
    debouncedSearchQuery,
    debouncedCategory,
    debouncedSeason
  ]);

  const renderEventContent = (eventInfo) => {

    // Ensure we have class names
    const classNames = eventInfo.event.classNames
      ? eventInfo.event.classNames
      : ['bda-normal-event'];

    const icon = getEventIcon(classNames);

    return (
      <div className="flex items-center justify-center bda-calendar-event">
        <div className="flex flex-col items-center justify-center">
          <div className="w-5 h-5">
            {icon}
          </div>
        </div>
      </div>
    );
  };

  const getEventIcon = (classNames) => {
    // Ensure classNames is an array and convert to lowercase string
    const classString = (Array.isArray(classNames) ? classNames : [classNames])
      .join(' ')
      .toLowerCase();

    if (classString.includes('fast')) {
      return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.42297 7.18739L7.42298 7.18738C8.03057 6.72604 8.82211 6.24263 9.15886 6.10805C10.5114 5.56775 12.3617 5.76784 13.7473 6.64241C14.3607 7.0296 15.0208 7.65071 15.5271 8.27628C15.7791 8.58751 15.9835 8.88834 16.1223 9.14892C16.2427 9.37486 16.2934 9.5333 16.3078 9.62539C16.3013 9.63882 16.2925 9.65566 16.2812 9.67612C16.2337 9.76211 16.1585 9.87948 16.057 10.022C15.8552 10.3053 15.5715 10.6573 15.2565 11.005L15.2564 11.0051C14.0377 12.3508 12.6515 12.981 11.4345 12.9907C10.894 12.9949 10.0788 12.8826 9.27308 12.648C8.45767 12.4105 7.72727 12.0694 7.30002 11.662C7.30002 11.662 7.30001 11.662 7.30001 11.662L7.28132 11.6442C7.08538 11.4573 6.90882 11.2889 6.74976 11.1683C6.57935 11.0391 6.37311 10.9199 6.11339 10.9011C5.8607 10.8827 5.63605 10.9655 5.442 11.0606C5.25424 11.1526 5.03331 11.2885 4.77897 11.445L4.75897 11.4573L4.75889 11.4574C4.4827 11.6274 4.17652 11.7825 3.91017 11.8936C3.77704 11.9491 3.6599 11.9911 3.56587 12.0184C3.49767 12.0382 3.4553 12.0462 3.43458 12.0493C3.42656 12.0231 3.41703 11.976 3.41731 11.9003C3.41827 11.6349 3.54184 11.2099 3.84443 10.7503L3.84454 10.7501C4.07555 10.3989 4.29192 10.0597 4.29192 9.63517C4.29192 9.42752 4.24144 9.23087 4.17037 9.03602C4.10018 8.84362 3.99894 8.62467 3.87778 8.37163L3.87768 8.37142C3.7425 8.08944 3.6193 7.78326 3.53092 7.52085C3.48672 7.38964 3.45295 7.27444 3.43079 7.18219C3.42279 7.14891 3.41673 7.12035 3.41231 7.09644C3.44013 7.09276 3.47853 7.09028 3.52972 7.09206C3.8128 7.10193 4.26992 7.2358 4.80708 7.5427L4.8071 7.54271C5.02859 7.66924 5.23554 7.78648 5.42508 7.86196C5.62917 7.94325 5.84833 7.99144 6.09531 7.95324C6.32808 7.91723 6.5349 7.81162 6.72999 7.68788C6.92494 7.56422 7.15229 7.3929 7.42297 7.18739ZM16.325 9.58558C16.3251 9.58551 16.3246 9.58732 16.3231 9.59117C16.3242 9.58757 16.3249 9.58565 16.325 9.58558Z" stroke="#610F7F" />
          <circle cx="13.1297" cy="9.39985" r="0.818182" fill="#610F7F" />
        </svg>
      );
    } else if (classString.includes('feast')) {
      return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M7.81896 3.59267C7.68421 3.72552 7.68362 3.99038 7.68362 4.12323C7.68362 4.30982 7.60192 4.36477 7.32483 4.36477C6.94693 4.36477 6.58115 4.5172 6.58115 4.90823C6.58115 5.24247 6.79833 5.38752 7.32483 5.45169C7.64932 5.45169 7.68362 5.48997 7.68362 5.85168C7.68362 6.15481 7.59591 6.31555 7.32103 6.51591C7.12173 6.66119 6.97261 6.72226 6.86167 6.78232C6.64426 6.90004 5.74327 7.42011 5.32777 7.76804C4.99298 8.04823 4.99298 8.04823 4.9909 10.8609C4.9887 13.6738 4.9887 13.6738 5.99929 13.6386C7.00989 13.6036 7.00989 13.6036 7.07114 12.3549C7.1292 11.1705 7.15015 11.091 7.47611 10.815C7.93499 10.4264 8.59965 10.4264 9.09233 10.815C9.44892 11.0963 9.46166 11.142 9.52107 12.3543C9.58232 13.6036 9.58232 13.6036 10.5929 13.6386C11.6035 13.6738 11.6035 13.6738 11.6035 10.8519C11.6035 7.64256 11.6883 7.90898 10.4398 7.19427C10.1029 7.0014 9.71707 6.77713 9.58232 6.69585C9.44757 6.6147 9.21324 6.48294 9.06171 6.40323C8.8602 6.29732 8.78609 6.14974 8.78609 5.85494C8.78609 5.46449 8.78609 5.38752 9.28327 5.38752C9.68723 5.38752 9.94105 5.24247 9.94105 4.87983C9.94105 4.44467 9.42945 4.36773 9.18421 4.36658C8.82505 4.36489 8.78609 4.32974 8.78609 4.00669C8.78609 3.77626 8.74091 3.63127 8.55241 3.50182C8.25092 3.26896 8.18645 3.29077 7.81896 3.59267ZM3.17759 9.38893C2.57393 9.70703 2.03493 10.1364 1.93118 10.2907C1.78884 10.5023 1.74609 10.8794 1.75699 11.8265C1.77622 13.5051 1.86564 13.6036 3.3688 13.6036C4.43746 13.6036 4.43746 13.6036 4.4709 11.3178C4.48928 10.0606 4.65471 9.07162 4.40965 8.94264C4.1646 8.81367 3.78126 9.07082 3.17759 9.38893ZM12.216 11.2592C12.216 13.6888 12.216 13.6888 13.2679 13.6462C14.2431 13.6067 14.3412 13.579 14.6153 13.2647C14.8847 12.9559 14.9109 12.8199 14.9109 11.7317C14.9109 10.2814 14.8542 10.1995 13.2878 9.38623C12.216 8.82972 12.216 8.82972 12.216 11.2592Z" fill="#1A856B" />
        </svg>
      );
    } else if (classString.includes('abstinence')) {
      return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M8.68724 5.44377C8.28799 5.60332 7.45407 6.11876 6.83449 6.58921C5.73282 7.42563 5.68667 7.43287 4.76899 6.90861C3.61675 6.2503 2.61719 6.21537 2.61719 6.83372C2.61719 7.08735 2.85269 7.78688 3.14068 8.38761C3.62749 9.40434 3.62749 9.53524 3.14068 10.2754C2.4645 11.3025 2.46071 12.3513 3.13309 12.3513C3.41696 12.3513 4.1377 12.0508 4.73485 11.6833C5.8207 11.0152 5.8207 11.0152 6.66884 11.8239C7.6959 12.8032 9.95613 13.3001 11.1523 13.2907C12.5397 13.2797 14.0511 12.565 15.3408 11.1407C15.993 10.4211 16.5263 9.67213 16.5263 9.47671C16.5263 8.66704 15.068 6.8655 13.728 6.01964C12.2214 5.06867 10.2036 4.83801 8.68724 5.44377ZM13.263 9.07896C13.3651 9.82921 12.4168 9.98655 12.1007 9.67187C11.9426 9.51453 11.7845 9.19985 11.9426 8.88517C12.2113 8.35014 13.049 8.41315 13.263 9.07896Z" fill="#E84A5A" />
        </svg>
      );
    } else {
      return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="7" stroke="#876B2E" strokeWidth="1.5" />
        </svg>
      );
    }
  };

  const handleLoadMore = async () => {
    if (loadingMore || !hasMore) return;
    try {
      setLoadingMore(true);
      const response = await fetchPrayerRitesListData(offset, itemsPerPage, searchQuery, selectedCategory);
      const responseData = response.data || [];
      const includedData = response.included || [];
      const newOffset = offset + itemsPerPage;
      const transformedData = mapPrayerRitesListData(responseData, includedData);

      setOffset(newOffset);
      setHasMore(newOffset < totalItems);
      setPrayersData((prev) => ({
        items: [...prev.items, ...transformedData.map(item => ({
          ...item,
          // favorite: favoriteIds.has(item.id),
        }))]
      }));
    } catch (error) {
      console.error("Error loading more data:", error);
      setError("Failed to load more items.");
    } finally {
      setLoadingMore(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setFilter(formData);
    console.log("Selected Values:", Object.fromEntries(formData.entries()));
  };

  const handleToggleFavorite = async (id, event) => {
    if (event) {
      event.preventDefault();  // Fix: Prevent default page reload
      event.stopPropagation(); // Fix: Stop event bubbling
    }
    const currentFavorite = prayersData.items.find(item => item.id === id)?.favorite;


    // Step 1: Optimistically update UI without reloading everything
    setPrayersData((prevData) => ({
      items: prevData.items.map(item =>
        item.id === id ? { ...item, favorite: !item.favorite } : item
      )
    }));

    // Step 2: Call API but **do NOT reload all favorites**
    try {
      await toggleFavorite('prayer-rites', id ,false, currentFavorite);
    } catch (error) {
      console.error(`Failed to update favorite status for ${id}:`, error);
    }
  };

  const handleSearchQuery = (value) => {
    setSearchQuery(value.trim()); // Ensure state updates
    setDebouncedSearchQuery(value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // 500ms debounce time

    return () => {
      clearTimeout(handler); // Clear timeout if user keeps typing
    };
  }, [searchQuery]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCategory(selectedCategory);
    }, 500);

    return () => clearTimeout(handler);
  }, [selectedCategory]);

  useEffect(() => {

    console.log(selectedSeason, '---------selectedSeason');

    const handler = setTimeout(() => {
      setDebouncedSeason(selectedSeason);
    }, 500);

    return () => clearTimeout(handler);
  }, [selectedSeason]);

  useEffect(() => {
    if (Array.isArray(prayersData.items) && prayersData.items.length > 0) {
      const items = prayersData.items.map(item => ({
        id: item.id,
        name: item.title || item.name,
      }));
      setSearchItems(items);
    }
  }, [prayersData.items]);
  return (
    <>
      <div className="bg-white-50 max-w-full w-full lg:w-[60%] xl:w-[67.33%]">
        <div className="px-4 py-8 pl-6 xl:px-6">
          <div className='mb-4 md:mb-6'>
            <div className='flex flex-wrap items-center justify-between gap-6 md:gap-3'>
              <div className="flex items-center gap-2">
                <span className='w-6 h-6 mt-px text-gold-200'>
                  <BookOpen className='w-full h-full text-white-50' />
                </span>
                <h1 className='text-2xl font-bold leading-7 text-gray-900 md:text-xl xl:text-2xl font-cmr'>
                  Prayer & Rites
                </h1>
              </div>
              <SearchBar
                inputName="s"
                inputPlaceholder="Search by name"
                items={searchItems} // Pass filtered search items
                onSearch={handleSearchQuery}
              />
            </div>
            <div className='mt-8'>
              <form onSubmit={handleSubmit} className="">
                <h5 className="font-bold leading-5 text-gray-900 font-base">All Items</h5>
                <div className='flex flex-wrap gap-3 mt-4'>
                  <div className=''>
                    <PrayerTypesDropdown value={selectedCategory} onChange={(value) => setSelectedCategory(value)} />
                  </div>
                  <div className=''>
                    <SeasonsDropdown value={selectedSeason} onChange={(value) => setSelectedSeason(value)} />
                  </div>
                </div>
              </form>
            </div>
          </div>
          {error && (
            <div className="py-4 text-center text-red-500">{error}</div>
          )}
          {loading ? (
            <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2">
              {Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="rounded-lg">
                  <Skeleton className="h-[102px] w-full mb-2" />
                </div>
              ))}
            </div>
          ) : (
            <PrayersList data={{ items: prayersData.items || [] }} // Ensure it's always an array
              searchQuery={searchQuery} isLoading={loading} onToggleFavorite={(id, event) => handleToggleFavorite(id, event)}
            />
          )}

          {hasMore && prayersData.items.length > 0 && (
            <div className="flex justify-center mt-6">
              <LoadMoreButton
                label="Load More"
                onClick={handleLoadMore}
                isLoading={loadingMore}
                disabled={!hasMore || loadingMore}
              />
            </div>
          )}
        </div>
      </div>
      <div className="lg:ml-0 md:h-auto bg-gold-50 max-w-full w-full lg:w-[40%] xl:w-[32.67%]">
        <div className="top-0 flex flex-col px-4 py-8 xl:px-6 md:sticky">
          <DayCard data={dayData} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
}
export default PagePrayerAndRites;
